import { Injectable, isDevMode } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { KeycloakService, KeycloakAuthGuard } from 'keycloak-angular-26';

@Injectable()
export class AppAuthGuard extends KeycloakAuthGuard  {
  constructor(
    override readonly router: Router,
    override readonly keycloakAngular: KeycloakService
  ) {
    super(router, keycloakAngular);
  }

  isAccessAllowed(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean> {
    return new Promise((resolve, _reject) => {
      // if (isDevMode()) {
      //   return resolve(true);
      // }

      if (!this.authenticated) {
        this.keycloakAngular.login({redirectUri: '/'});
        return;
      }

      const requiredRoles = route.data['roles'];
      if (!requiredRoles || requiredRoles.length === 0) {
        return resolve(true);
      } else {
        if (!this.roles || this.roles.length === 0) {
          resolve(false);
        }
        let granted = false;
        for (const requiredRole of requiredRoles) {
          if (this.roles.indexOf(requiredRole) > -1) {
            granted = true;
            break;
          }
        }
        resolve(granted);
      }
    });
  }
}
